var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spinner", style: _vm.styles }, [
    _c("div", { staticClass: "blob top", style: _vm.blobStyles }),
    _vm._v(" "),
    _c("div", { staticClass: "blob bottom", style: _vm.blobStyles }),
    _vm._v(" "),
    _c("div", { staticClass: "blob left", style: _vm.blobStyles }),
    _vm._v(" "),
    _c("div", { staticClass: "blob move-blob", style: _vm.moveBlobStyles })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28beac0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28beac0f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/ThreeDots.vue
// module id = 4iY+
// module chunks = 0